import clsx from "clsx";
import { useState } from "react";
import RichText from "@/components/elements/RichText";
import * as styles from "./styles.module.scss";

export function RichTextAccordion({
  content,
  title,
}: Partial<AccordionComponent>) {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  return (
    <div
      className={clsx(
        {
          [styles.isOpen]: isAccordionOpen,
          [styles.withCustomTitle]: !!title,
        },
        styles.accordionContainer
      )}
    >
      <button
        type="button"
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        className={clsx(
          { [styles.isOpen]: isAccordionOpen },
          styles.accordionButton
        )}
      >
        {title ? title : isAccordionOpen ? "Hide" : "Read more"}
        <img src={`svgs/chevronGreen.svg`} alt="chevron" data-svg="true" />
      </button>

      <div
        className={clsx(
          {
            [styles.isOpen]: isAccordionOpen,
          },
          styles.accordion
        )}
        role="button"
        aria-hidden="true"
      >
        {" "}
        <RichText content={content} />
      </div>
    </div>
  );
}
